import clsx from 'clsx';

/**
 * Form Progress Bar Component
 * A gradient progress bar with a badge indicator showing completion percentage
 * 
 * @param {number} percentage - Progress percentage (0-100)
 * @param {string} className - Additional classes for the container
 */
const FormProgressBar = ({ percentage = 0, className = "" }) => {
  // Ensure percentage is between 0 and 100
  const clampedPercentage = Math.min(100, Math.max(0, percentage));
  
  return (
    <div className={clsx("relative w-full", className)}>
      <div className="h-12 bg-gray-200 rounded-full overflow-hidden relative">
        <div 
          className="h-full rounded-full transition-all duration-500 ease-out relative"
          style={{ 
            width: `${clampedPercentage}%`,
            background: 'linear-gradient(90deg, #FFD066 0%, #FF9F43 30%, #FF6B8A 70%, #FF4D7D 100%)'
          }}
        >
          {clampedPercentage > 20 && (
            <span className="absolute right-4 top-1/2 -translate-y-1/2 text-white text-2xl font-bold geomanistBold">
              {Math.round(clampedPercentage)}%
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormProgressBar;
